/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import React, { useMemo, useState } from 'react';
import PhotoLightbox from './PhotoLightbox';

export default function GalleryBlock({ images = [] }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const uniqueImages = useMemo(() => {
    const seen = new Set();
    const dedupedImages = images.filter((image) => {
      if (!image?.src || seen.has(image.src)) {
        return false;
      }

      seen.add(image.src);
      return true;
    });

    const photoImages = dedupedImages.filter((image) => {
      const src = image.src.toLowerCase();

      if (src.includes('fsflogo') || src.includes('gb1') || src.includes('creditlogos')) {
        return false;
      }

      return true;
    });

    return photoImages.length >= 4 ? photoImages : dedupedImages;
  }, [images]);

  if (!uniqueImages.length) {
    return null;
  }

  return (
    <>
      <section className="fsf-gallery" aria-label="Freight Services Fiji photo gallery">
        {uniqueImages.map((image, index) => {
          const alt = image.alt || `Freight Services Fiji gallery photo ${index + 1}`;

          return (
            <figure key={`${image.src}-${index}`} className="fsf-gallery__item">
              <button
                className="fsf-gallery__button"
                type="button"
                onClick={() => setActiveIndex(index)}
                aria-label={`Open gallery photo ${index + 1} of ${uniqueImages.length}`}
              >
                <img src={image.src} alt={alt} loading={index < 4 ? 'eager' : 'lazy'} />
                <span className="fsf-gallery__overlay" aria-hidden="true">
                  View Photo
                </span>
              </button>
            </figure>
          );
        })}
      </section>

      <PhotoLightbox images={uniqueImages} activeIndex={activeIndex} setActiveIndex={setActiveIndex} />
    </>
  );
}
